import { SettingService } from './../../../services/setting.service';
import { ThemeConstantService } from './../../../services/theme-constant.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import messages from 'src/assets/data/global/header/messages.json';
import notification from 'src/assets/data/global/header/notification.json';
import authorMenu from 'src/assets/data/global/header/author-menu.json';
import settings from 'src/assets/data/global/header/settings.json';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Default
})

export class HeaderComponent implements OnInit, OnDestroy, OnChanges {

    searchVisible : boolean = false;
    quickViewVisible : boolean = false;
    isFolded : boolean;
    isExpand : boolean;
    appMessages = messages.appMessages;
    appNotification = notification.appNotification;
    //appAuthorMenu = authorMenu.appAuthorMenu; // hexadash menu abaixo do icone
    appAuthorMenu = authorMenu.LacpointAppAuthorMenu; // armazena o conteúdo dentro de LacpointAppAuthorMenu no json
    appSettings = settings.appSettings;

    tipoUsuario; //armazena o tipo de usuário logado no momento
    nomeUsuario; //armazena o nome do usuário logado no momento
    avatarUrl = ''

    constructor(
      private themeService: ThemeConstantService,
      private authService: AuthenticationService,
      private router: Router,
      private settingService: SettingService,
      private cdr: ChangeDetectorRef,
    ) {}

    signOut(): void {
      this.authService.logout()
    }

    ngOnInit(): void {
      this.authService.userContext.subscribe(user => {
        this.nomeUsuario = user.name.split(' ').slice(0, 2).join(' ');
        this.tipoUsuario = user.type
        this.defineTipoUsuario()
      })
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
      this.settingService.avatarUrl.subscribe(avatarUrl =>
        this.avatarUrl = avatarUrl || ''
      )
      this.settingService.setAvatar()
      this.cdr.detectChanges()
    }

    ngOnChanges(changes: SimpleChanges) {
      console.log('HEADER SIMPLE CHANGES: ', changes)
    }

  ngOnDestroy() {
      console.log('HEADER DESTROYED')
    }

  defineTipoUsuario(){ // método para trocar o valor do número inteiro por uma string com o tipo de usuário logado no sistema.
       switch (this.tipoUsuario) {
        case 1:
          this.tipoUsuario = "Produtor";
          break;
        case 2:
          this.tipoUsuario = "Laticínio";
          break;
        case 3:
          this.tipoUsuario = "Laboratório";
          break;
        default:
          this.tipoUsuario = "Usuário";
          break;
       }
    }

    // Método que recebe uma url e direcionada para a página.
    navegar(url: string){
      this.router.navigate([url]);
    }

    toggleFold() {
        this.isFolded = !this.isFolded;
        this.themeService.toggleFold(this.isFolded);
    }

    toggleExpand() {
        this.isFolded = false;
        this.isExpand = !this.isExpand;
        this.themeService.toggleExpand(this.isExpand);
        this.themeService.toggleFold(this.isFolded);
    }

    searchToggle(): void {
        this.searchVisible = !this.searchVisible;
    }

    quickViewToggle(): void {
        this.quickViewVisible = !this.quickViewVisible;
    }
}
